import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import { Route, Switch, Redirect } from 'react-router-dom';
import './main-panel.css';
import UserProfile from '../user-profile/UserProfile';
import ApplicationBuilderPanel from '../application-builder/ApplicationBuilderPanel';
import TenantsPanel from '../tenants-panel/TenantsPanel';
import AppDashboard from '../app-dashboard/AppDashboard';
import ActivityLog from '../activity-log/ActivityLog';
import UserManagement from '../user-management/UserManagement';
import Migrations from '../migrations/Migrations';
import AppComposer from '../app-composer/AppComposer';
import AppModules from '../app-modules/AppModules';
import ConnectionsPanel from '../connections-panel/ConnectionsPanel';
import EndpointsPanel from '../endpoints-panel/EndpointsPanel';
import EntitiesPanel from '../entities-panel/EntitiesPanel';
import TenantList from '../tenant-list/TenantList';

class MainPanel extends ComponentHelper {
	render() {
		return (
			<div className="main-panel grow-1 animated fadeIn">
				<Switch>
					<Route exact path="/" render={() => <Redirect to="/tenants" />} />
					<Route path="/tenants" component={TenantList} />
					<Route path="/tenant-management/:tenant/" component={TenantsPanel} />
					<Route path={`/migrations`} component={Migrations} />
					<Route path={`/dashboard`} component={AppDashboard} />
					<Route path={`/app-composer`} component={AppComposer} />
					<Route path={`/activity-log`} component={ActivityLog} />
					<Route path={`/modules`} component={AppModules} />
					<Route path={`/connections`} component={ConnectionsPanel} />
					<Route path={`/endpoints`} component={EndpointsPanel} />
					<Route path={`/entities`} component={EntitiesPanel} />
					<Route path="/application-builder" component={ApplicationBuilderPanel} />
					<Route path="/user-profile" component={UserProfile} />
					<Route path="/manage-users/users/" component={UserManagement} />
				</Switch>
			</div>
		);
	}
}

export default MainPanel;



// WEBPACK FOOTER //
// ./src/views/main-panel/MainPanel.js